import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
// @material-ui/core components
import {
  Dialog,
  IconButton,
  Icon,
  Grid,
  CircularProgress,
  Typography,
} from "@material-ui/core";
// @material-ui/styles
import styles from "../../assets/jss/layouts/appStyle";
import { makeStyles } from "@material-ui/core/styles";
// core components
import { LOCALE } from "../../properties/Locale";
import { LoginRepository } from "./LoginRepository";

const useStyles = makeStyles(styles);

export default function ConfirmEmailComponent(props) {
  const classes = useStyles();
  const [isVerified, setIsVerified] = React.useState(false);
  const [counter, setCounter] = React.useState(5);
  const [redirectTo, setRedirectTo] = React.useState();

  useEffect(() => {
    LoginRepository.verifyUser(props.match.params.token).then((res) => {
      setIsVerified(true);
      countDown();
    });
  }, []);

  const countDown = () => {
    let number = 4;
    setInterval(() => {
      if (number === 0) {
        setRedirectTo("/login");
      }
      setCounter(number);
      number = number - 1;
    }, 1000);
  };

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <Grid container style={{ marginTop: "15%" }}>
        <Grid item xs={4}></Grid>
        <Grid item xs={4} style={{ textAlign: "center" }}>
          {isVerified ? (
            <div>
              <Icon color="secondary" style={{ fontSize: "5.5em" }}>
                check_circle_outline
              </Icon>
              <Typography variant="h3">{LOCALE.email_verified}</Typography>
              <br></br>
              <Typography variant="h5" component="h4">
                {LOCALE.forbidden_h2 + counter}
              </Typography>
            </div>
          ) : (
            <div>
              <CircularProgress color="secondary" size={80} />
              <Typography variant="h3">{LOCALE.verifying_email}</Typography>
            </div>
          )}
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
    </div>
  );
}
